// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"257":"ef999627","751":"1ab0a68e"}[chunkId] + ".chunk.css";
};